import { Component, OnInit } from '@angular/core';
import { Cliente } from '../../../models/cliente';
import { Proveedor } from '../../../models/proveedor';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ClienteModalComponent } from '../../modals/cliente-modal/cliente-modal.component';
import { ProveedorModalComponent } from '../../modals/proveedor-modal/proveedor-modal.component';
import { ClienteService } from '../../../services/cliente.service';
import { ProveedorService } from '../../../services/proveedor.service';
import { VentaService } from '../../../services/venta.service';
import { CompraService } from '../../../services/compra.service';
import { Venta } from '../../../models/venta';
import { Compra } from '../../../models/compra';
import { Retencion } from '../../../models/retencion';
import { UtilsService } from '../../../services/utils.service';
import { ParametroService } from '../../../services/parametro.service';
import { NotaCreditoService } from '../../../services/nota-credito.service';
import { NotaCredito } from '../../../models/nota-credito';
import { not } from '@angular/compiler/src/output/output_ast';
import { IfObservable } from 'rxjs/observable/IfObservable';

import * as moment from 'moment';
import { Pago } from '../../../models/pago';
import { PagoService } from '../../../services/pago.service';
import { CobroService } from '../../../services/cobro.service';
import { Cobro } from '../../../models/cobro';
import { PagoDetalle } from '../../../models/pago_detalle';
import { SessionService } from '../../../services/session.service';
import { CobroDetalle } from '../../../models/cobro_detalle';
import { SweetMessage } from '../../../config/sweet-message';
import { Cruce } from '../../../models/cruce';
import { CruceService } from '../../../services/cruce.service';
@Component({
  selector: 'app-cruce-nota-credito',
  templateUrl: './cruce-nota-credito.component.html',
  styleUrls: ['./cruce-nota-credito.component.css'],
  providers: [ 
    ClienteService, 
    ProveedorService, 
    CompraService, 
    VentaService, 
    ParametroService, 
    UtilsService, 
    NotaCreditoService,
    PagoService,
    CobroService, 
    CruceService,],
})
export class CruceNotaCreditoComponent implements OnInit {
  public tipos: Array<any>;
  public tipo: String;
  public cliente: Cliente;
  public proveedor: Proveedor;
  public bsModalRef: BsModalRef;
  public loading: boolean;
  public ventas: Array<Venta>;
  public compras: Array<Compra>;

  public fecha_cruce: any;
  //FACTURAS

  public total_pago: number;
  public total_facturas: number;
	public total:any;
	public total_retencion:any;
	public total_a_cobrar:any;
	public total_cobrado:any;
  public total_saldo:any;
  
  //NOTAS CRÉDITO

  public total_nc: number;
  public total_utilizado_nc: number;
  public total_saldo_nc: number;
  public total_a_cruzar: number;

	public fecha_cobro: any;
  public selectAll: boolean;
  public selectAllNC: boolean;
  public factura: any;
  public notas: Array<NotaCredito>;
  
  public numero_decimales: number;
  public format_decimal: String;
  public msg: SweetMessage;

  //PAGO

  public pago: Pago;
  public cobro: Cobro;
  public cruce: Cruce;


  constructor(
    public modalService: BsModalService,
    public clienteService: ClienteService,
    public proveedorService: ProveedorService,
    public ventaService: VentaService,
    public compraService: CompraService,
    public utils: UtilsService,
    private parametroService: ParametroService,
    public notaService: NotaCreditoService,
    public pagoService: PagoService,
    public cobroService: CobroService,
    public cruceService: CruceService,
    public ss: SessionService,
  ) {
    this.tipos = ["seleccione","proveedor", "cliente"];
    this.tipo = this.tipos[0];
    this.cliente = new Cliente();
    this.proveedor = new Proveedor();
    this.cruce = new Cruce();
    this.loading = false;
    this.compras = [];
    this.ventas = [];
    this.notas =[];
    let now = moment();
    this.fecha_cruce = moment(now.format(), moment.ISO_8601).format();
    this.msg = new SweetMessage();

    //FACTURAS

    this.total_facturas = 0;
		this.total =0;
		this.total_retencion = 0;
		this.total_a_cobrar = 0;
		this.total_cobrado = 0;
		this.total_pago = 0;
    this.total_saldo = 0;

    //NOTAS DE CRÉDITO

    this.total_nc = 0;
    this.total_utilizado_nc = 0;
    this.total_saldo_nc = 0;
    this.total_a_cruzar = 0;

    //PAGO/COBRO
    this.pago = new Pago();
    this.cobro = new Cobro();

    this.numero_decimales = 2;
        this.format_decimal = "0,0.00";
        this.factura = null;
        this.notas = [];
  }
  ngOnInit() {
    this.loading = true;
    this.getParamNumeroDecimales().then(
      res => this.loading = false,
      err => this.loading = false,
    );
}

onChange(){
  this.notas = [];
  this.compras = [];
  this.ventas = [];
  this.notas = [];

  this.total_facturas = 0;
  this.total = 0;
  this.total_retencion = 0;
  this.total_a_cobrar = 0;
  this.total_cobrado = 0;
  this.total_saldo = 0;

  this.total_nc = 0;
  this.total_utilizado_nc = 0;
  this.total_saldo_nc = 0;
  this.total_a_cruzar = 0;
}
getParamNumeroDecimales(){
    return new Promise((resolve, reject) => {
        let numero_decimales = 19;
        this.parametroService.getById(numero_decimales).subscribe(
            res => {
                this.numero_decimales = res.valor;

                let digitos = "";
                for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                this.format_decimal = "0,0." + digitos
                resolve();
            },
            err => {
                this.numero_decimales = 2;
                this.format_decimal = "0,0.00"
                reject(err);
            }
        );
    });
}

get formatDecimal(){
    return this.format_decimal;
}

openDialogCliente() {
  const initialState = {};
  this.bsModalRef = this.modalService.show(ClienteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

  this.bsModalRef.content.sendCliente.take(1).subscribe(cliente => {
    this.cliente = cliente;
    //this.compras = [];
    
    this.getFacturasCredito(this.cliente.id);
    this.getNotasCredito(this.cliente.id);

  });
  }

    openDialogProveedor() {
      const initialState = {};
      this.bsModalRef = this.modalService.show(ProveedorModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));
  
      this.bsModalRef.content.sendProveedor.take(1).subscribe(proveedor => {
        this.proveedor = proveedor;
       // this.ventas = []
        this.getFacturasCredito(this.proveedor.id);
        this.getNotasCredito(this.proveedor.id);
      });
    }

   

  onSearchCliente(event) {

    if( event.keyCode === 13 ){
      this.loading = true;
      if( this.cliente.dni.toString().trim().length == 0 ){
        this.cliente = new Cliente();
        this.ventas = [];
        this.compras = [];
        return;
      }else{
        this.loading = true;
        this.clienteService.getByDni(this.cliente.dni).subscribe(
          res => {
            if (res) {
              this.cliente = res[0];

              this.getFacturasCredito(this.cliente.id);
              this.loading = false;
            }else{
              this.loading = false;
              this.cliente = new Cliente();
              this.ventas = [];
              this.openDialogCliente();
            }
          },
          err => {
            this.loading = false;
            this.ventas = [];
            this.openDialogCliente();
          }
        );
      }
    }
  }

  onSearchProveedor(event) {

		if( event.keyCode === 13 ){
      this.loading = true;
			if( this.proveedor.dni.toString().trim().length == 0 ){
        this.proveedor = new Proveedor();
        this.ventas = [];
				this.compras = [];
				return;
			}else{
				this.proveedorService.getByDni(this.proveedor.dni).subscribe(
					res => {
						this.loading = false;
						if (res) {
							this.proveedor = res[0];
							this.compras = [];
							this.getFacturasCredito(this.proveedor.id);
						}else{
							this.proveedor = new Proveedor();
							this.compras = [];
							
							this.openDialogProveedor();
						}
					},
					err => {
						this.loading = false;
						this.compras = [];
						this.openDialogProveedor();
						
					}
				);
			}
		}
  }

  getFacturasCredito(id){
    return new Promise((resolve, reject) => {
      this.loading = true;
      let facturaService =  (this.tipo=="cliente"?(this.ventaService):(this.compraService));
      let qs = (this.tipo=="cliente"?("&cliente_id="):("&proveedor_id="));
      facturaService.getAll("?tipo=CR&embed=tipocomprobante,retencion&estado_pago=P"+ qs + id +"&sort=-fecha_emision,-secuencial&status=A").subscribe(
        res => {
          if( res ){
            if(this.tipo == "cliente"){
              this.loading = false;
              this.ventas = res.data;
              this.ventas.forEach((venta: Venta) => {
                if( !venta.retencion ){
                  venta.retencion = new Retencion();
                }
              });
            }
            
            if(this.tipo == 'proveedor'){
              this.loading = false;
              this.compras = res.data;
              this.compras.forEach((compra: Compra) => {
                if( !compra.retencion ){
                  compra.retencion = new Retencion();
                }
              });
            }
            this.total_facturas = 0;
            this.calcularTotalFacturas();
            
          }else{
            this.ventas = [];
            this.compras = [];
          }
          resolve();
        },
        err => {
          this.ventas = [];
          this.compras = [];
          reject(err);
        }
      );
    });
  }

  calcularTotalFacturas(){
    this.total_facturas = 0;
    this.total =0;
    this.total_retencion = 0;
    this.total_a_cobrar = 0;
    this.total_cobrado = 0;
    this.total_pago = 0;
        this.total_saldo = 0;
    if( this.tipo == "cliente"){
      this.calcularVenta();
    }
    if(this.tipo == "proveedor"){
      this.calcularCompra();
    }
  }

  

  calcularVenta(){
    this.ventas.map(venta => {
      this.total += (parseFloat(venta.total.toString()));
      this.total = this.utils.redondear(this.total,this.numero_decimales);
      this.total_retencion += (parseFloat(venta.retencion.total.toString()));
      this.total = this.utils.redondear(this.total,this.numero_decimales);
      this.total_a_cobrar += (parseFloat(venta.total.toString()) - parseFloat(venta.retencion.total.toString()));
      this.total_a_cobrar = this.utils.redondear(this.total_a_cobrar,this.numero_decimales);
      this.total_cobrado += (parseFloat(venta.abonado.toString()));
      this.total_cobrado = this.utils.redondear(this.total_cobrado,this.numero_decimales);
      this.total_saldo += (this.calcSaldo(venta));
      this.total_saldo = this.utils.redondear(this.total_saldo,this.numero_decimales);
      if(venta.selected){
        this.total_facturas += (venta.total - venta.abonado - venta.retencion.total);
        this.total_facturas = this.utils.redondear(this.total_facturas,this.numero_decimales);
        
        //this.calcularCambio();
      }
      
    });

  }

  calcularCompra(){
    this.compras.map(compra => {
      this.total += (parseFloat(compra.total.toString()));
      this.total = this.utils.redondear(this.total,this.numero_decimales);
      this.total_retencion += (parseFloat(compra.retencion.total.toString()));
      this.total = this.utils.redondear(this.total,this.numero_decimales);
      this.total_a_cobrar += (parseFloat(compra.total.toString()) - parseFloat(compra.retencion.total.toString()));
      this.total_a_cobrar = this.utils.redondear(this.total_a_cobrar,this.numero_decimales);
      this.total_cobrado += (parseFloat(compra.abonado.toString()));
      this.total_cobrado = this.utils.redondear(this.total_cobrado,this.numero_decimales);
      this.total_saldo += (parseFloat(compra.total.toString()) - parseFloat(compra.abonado.toString()) - parseFloat(compra.retencion.total.toString()));
      this.total_saldo = this.utils.redondear(this.total_saldo,this.numero_decimales);
      if(compra.selected){
        this.total_facturas += (compra.total - compra.abonado - compra.retencion.total);
        this.total_facturas = this.utils.redondear(this.total_facturas,this.numero_decimales);
        
        //this.calcularCambio();
      }
      
    });
  }

  onSelectAll(){
    if( this.tipo == "cliente" ){
      this.ventas.map(venta => venta.selected = this.selectAll);
    }
    if(this.tipo == "proveedor"){
      this.compras.map(compra => compra.selected = this.selectAll);
    }
    this.calcularTotalFacturas();
  }

  

  calcSaldo(factura){
    let saldo = factura.total - factura.abonado;

    if( factura.retencion ){
        saldo = saldo - factura.retencion.total;
    }
//return saldo = Math.round(saldo * 100) / 100;
    return saldo = this.utils.redondear(saldo, this.numero_decimales);
  }

  numeroFactura(factura){
    return factura.serie + "-" + factura.punto_emision + "-" + factura.secuencial;
  }


  //Notas de crédito
  
  getNumeroDocumento(nota){
    if(this.tipo == "cliente")
      return nota.serie + '-' + nota.punto_emision + '-' + nota.secuencial;
    else  
      return nota.numero_documento;

    
  }

  getNotasCredito(id) {
    let qs = "?sort=-fecha_emision&estado_cobro=P";
    qs += (this.tipo == "cliente" ? "&embed=cliente&status=A&tipo=V&cliente_id=" + id : "&embed=proveedor&status=A&tipo=C&proveedor_id=" + id);

    // if (this.nota.tipo_comprobante_id) {
    //   qs += "&tipo_comprobante_id=" + this.nota.tipo_comprobante_id;
    // }

    return new Promise((resolve, reject) => {


      this.notaService.getAllByFilter(qs).subscribe(

        res => {
          if (!res.data.length) {
            this.notas = [];
          } else {
            this.notas = res.data;
            this.calcularTotalNotasCredito();
            this.total = 0;
            this.notas.forEach(x => this.total += parseFloat(x.total.toString()));
          }

          resolve();
        },
        err => {
          this.notas = [];
          reject();
        }
      );
    });


  }

  calcularTotalNotasCredito(){
    this.total_nc = 0;
    this.total_utilizado_nc = 0;
    this.total_saldo_nc = 0;
    this.total_a_cruzar = 0;
    this.notas.map(nota => {
      this.total_nc += (parseFloat(nota.total.toString()));
      this.total_nc = this.utils.redondear(this.total_nc,this.numero_decimales);
      this.total_utilizado_nc += (parseFloat(nota.valor_utilizado.toString()));
      this.total_utilizado_nc = this.utils.redondear(this.total_utilizado_nc,this.numero_decimales);
      this.total_saldo_nc += (parseFloat(nota.total.toString()) - parseFloat(nota.valor_utilizado.toString()));
      this.total_saldo_nc = this.utils.redondear(this.total_saldo_nc,this.numero_decimales);
      
      if(nota.valor_a_utilizar == null){
        nota.valor_a_utilizar = (parseFloat(nota.total.toString()) - parseFloat(nota.valor_utilizado.toString()));
        nota.valor_a_utilizar = this.utils.redondear(nota.valor_a_utilizar,this.numero_decimales);
        //nota.valor_a_utilizar = nota.total - nota.valor_utilizado;
      }

      if(nota.selected == true){
        this.total_a_cruzar += (parseFloat(nota.valor_a_utilizar.toString()));
        this.total_a_cruzar = this.utils.redondear(this.total_a_cruzar,this.numero_decimales);
        
        //this.calcularCambio();
      }

     
      
    });

  }

  disabledCheck(nota){
    if( nota.valor_a_utilizar > 0){
      return false;
    }else{
      return true;
    }
  }
  calSaldoDisponibleNC(nota){
    let saldo = (parseFloat(nota.total.toString()));
    saldo += (parseFloat(nota.valor_utilizado.toString()));
      
    return saldo;
  }

  onSelectAllNC(){
    if(this.notas.length > 0){
      this.notas.map(nota => nota.selected = this.selectAllNC);
    }  
    this.calcularTotalNotasCredito();
  }

  onEvento(nota, event?){
		if( nota.valor_a_utilizar > (nota.total - nota.valor_utilizado) ){
			if( event ){
				event.stopPropagation();
				if (event.key === "Enter" ) {
					nota.valor_a_utilizar = 0;
					this.calcularTotalNotasCredito();
				}
			}else{
        nota.valor_a_utilizar = 0;
        this.calcularTotalNotasCredito();
			}	
		
		}else if(nota.valor_a_utilizar <= 0){
      nota.selected = false;
    }else{
      nota.selected = true;
    }

    this.calcularTotalNotasCredito();
  }
  
  //PAGO/COBRO

  onSubmit(){

    
    this.msg.showMessage('delete-confirm-message', "¿Está seguro de confirmar el cruce?").then(
      res => {
        this.loading = true;
        if(this.tipo == "cliente")
          this.setValueEntityCobro();
        else 
          this.setValueEntityPago();
        
        let p1 = this.onSubmitFacturar();
        let p2 = this.onSubmitCruce();
        //this.loading = true;
        
        Promise.all([p1,p2]).then(
          res => {
            this.pago = new Pago();
            this.cobro = new Cobro();
            // this.datosPagos.total_cheque = 0;
            // this.datosPagos.total_tarjeta = 0;
            // this.datosPagos.total_efectivo = 0;
            // this.cheques = [];
            // this.tarjetas = [];
            this.total_a_cruzar = 0;
            this.proveedor = new Proveedor();
            this.cliente = new Cliente();
            let now = moment();
            this.fecha_cruce = moment(now.format(), moment.ISO_8601).format();
            this.compras = [];
            this.ventas = [];
            this.notas = [];

            this.total_facturas = 0;
            this.total = 0;
            this.total_retencion = 0;
            this.total_a_cobrar = 0;
            this.total_cobrado = 0;
            this.total_saldo = 0;

            this.total_nc = 0;
            this.total_utilizado_nc = 0;
            this.total_saldo_nc = 0;
            this.total_a_cruzar = 0;
            this.loading = false;
            
          },
          err => this.loading = false
        );
        
      });
  }

  onSubmitFacturar(){
    let tipo_fac = (this.tipo == "cliente")? this.cobro: this.pago;
        let tipo_facService = (this.tipo == "cliente")? this.cobroService:this.pagoService;
        tipo_facService.saveGrupo(tipo_fac).subscribe(
          res => {
            this.msg.showMessage('success-message', res.message);
            //this.venta = new Venta();
            //this.pago_grupo = new PagoGrupo();
          },
          err => {
            this.msg.showMessage('error-message',err);
          }
        );
  }

  onSubmitCruce(){
    this.setValueEntityCruce();
    this.cruceService.save(this.cruce).subscribe(
      res => {
        this.msg.showMessage('success-message', res.message);       
      },
      err => {
        this.msg.showMessage('error-message',err);
      }
    );
  }

  setValueEntityCruce(){
    this.cruce.tipo = (this.tipo == 'cliente')? 'CL':'PR';
    this.cruce.total_factura = this.total_facturas;
    this.cruce.total_cruce = this.total_a_cruzar;
    //this.pago.compra_id = this.compra.id;
    this.cruce.cliente_proveedor_id = (this.tipo == 'cliente')? this.cliente.id:this.proveedor.id;
    this.cruce.forma_pago_id = "5";
    this.cruce.crucefactura = [];
    this.cruce.crucedocumento = [];
    //this.pago.caja_id = this.ss.getData("caja_id");
    this.cruce.usuario_id = this.ss.getData("usuario_id");
    if(this.tipo == 'cliente'){
      this.ventas.forEach((venta: any, index: number) => {
        if( venta.selected ){

            
            venta.usuario_id = this.ss.getData("usuario_id");
            venta.empresa_id = this.ss.getData("empresa_id");

            this.cruce.crucefactura.push(venta);
        }

        /*if( this.compra_selected == false){
            this.pago.grupo.splice(index, 1);
        }*/
    });
    }else{
      this.compras.forEach((compra: any, index: number) => {
        if( compra.selected ){
    
          compra.usuario_id = this.ss.getData("usuario_id");
          compra.empresa_id = this.ss.getData("empresa_id");
    
          this.cruce.crucefactura.push(compra);
        }
    
        /*if( this.compra_selected == false){
          this.pago.grupo.splice(index, 1);
        }*/
      });
      
    }

    this.notas.forEach((nota: any, index: number) => {
      if( nota.selected ){

         // nota.estado_cobro = "C";
          nota.usuario_id = this.ss.getData("usuario_id");
          nota.empresa_id = this.ss.getData("empresa_id");
          nota.valor_utilizado = (parseFloat(nota.valor_utilizado.toString()));
          nota.valor_utilizado += (parseFloat(nota.valor_a_utilizar.toString()));
          this.cruce.crucedocumento.push(nota);
      }

      /*if( this.compra_selected == false){
          this.pago.grupo.splice(index, 1);
      }*/
  });
    
    //this.pago_grupo.pago_id = this.pago.id;
    //this.pago_grupo.pago = this.pago;
    //this.pago_grupo.compra_id = this.compra.id;
    //this.pago_grupo.compra = this.compra;
    //this.pago_grupo.usuario_id = this.ss.getData("usuario_id");
  }



  setValueEntityPago(){
    this.pago.fecha_pago = moment(this.fecha_cruce).format("YYYY-MM-DD");
    //this.pago.saldo = this.compra.total - this.compra.abonado;
    this.pago.saldo = this.total_facturas;
    this.pago.recibido = this.total_a_cruzar;
    this.pago.cambio = this.total_facturas - this.total_a_cruzar;
    //this.pago.compra_id = this.compra.id;
  
    this.pago.detalle = [];
    //this.pago.caja_id = this.ss.getData("caja_id");
    this.pago.empresa_id = this.ss.getData("empresa_id");
    this.pago.sucursal_id = this.ss.getData("sucursal_id");
    this.pago.usuario_id = this.ss.getData("usuario_id");
  
    if( this.total_a_cruzar > 0 ){
      let pago_detalle = new PagoDetalle();
      pago_detalle.valor = this.total_a_cruzar;
      pago_detalle.forma_pago_id = "5"; // EFECTIVO
      pago_detalle.empresa_id = this.ss.getData("empresa_id");
      pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
      pago_detalle.usuario_id = this.ss.getData("usuario_id");
      this.pago.detalle.push(pago_detalle);
    }
  
    this.compras.forEach((compra: any, index: number) => {
      if( compra.selected ){
  
        compra.usuario_id = this.ss.getData("usuario_id");
        compra.empresa_id = this.ss.getData("empresa_id");
  
        this.pago.grupo.push(compra);
      }
  
      /*if( this.compra_selected == false){
        this.pago.grupo.splice(index, 1);
      }*/
    });
    
    //this.pago_grupo.pago_id = this.pago.id;
    //this.pago_grupo.pago = this.pago;
    //this.pago_grupo.compra_id = this.compra.id;
    //this.pago_grupo.compra = this.compra;
    //this.pago_grupo.usuario_id = this.ss.getData("usuario_id");
  }

  setValueEntityCobro(){
    this.cobro.fecha_cobro = moment(this.fecha_cobro).format("YYYY-MM-DD");

    this.cobro.saldo = this.total_facturas;

    //this.cobro.saldo = this.venta.total - this.venta.abonado;
    this.cobro.recibido = this.total_a_cruzar;
    this.cobro.cambio = this.total_facturas - this.total_a_cruzar;
    this.cobro.tipo_doc = "FAC";
    this.cobro.tipo_documento_id = null;
  //  this.cobro.tipo_documento_id = (this.tipo=="VE"?this.venta.id:this.plan.id);
    //this.cobro.caja_id = this.ss.getData("caja_id");
    this.cobro.empresa_id = this.ss.getData("empresa_id");
    this.cobro.sucursal_id = this.ss.getData("sucursal_id");
    this.cobro.usuario_id = this.ss.getData("usuario_id");

    if( this.total_a_cruzar > 0 ){
        let cobro_detalle = new CobroDetalle();
        cobro_detalle.valor = this.total_a_cruzar;
        cobro_detalle.forma_pago_id = "5"; // EFECTIVO
        cobro_detalle.empresa_id = this.ss.getData("empresa_id");
        cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
        cobro_detalle.usuario_id = this.ss.getData("usuario_id");
        this.cobro.detalle.push(cobro_detalle);
    }

    // this.cheques.forEach(ch => {
    //     let cobro_detalle = new CobroDetalle();

    //     cobro_detalle.fecha_cheque = ch.fecha;
    //     cobro_detalle.numero_cta = ch.cuenta;
    //     cobro_detalle.numero_cheque = ch.numero;
    //     cobro_detalle.banco_id = ch.banco_id;
    //     cobro_detalle.observacion = ch.observacion;

    //     cobro_detalle.valor = ch.valor;
    //     cobro_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
    //     cobro_detalle.empresa_id = this.ss.getData("empresa_id");
    //     cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
    //     cobro_detalle.usuario_id = this.ss.getData("usuario_id");
    //     this.cobro.detalle.push(cobro_detalle);
    // });

    // this.tarjetas.forEach(tr => {
    //     let cobro_detalle = new CobroDetalle();

    //     cobro_detalle.debito_credito = tr.debito_credito;
    //     cobro_detalle.observacion = tr.observacion;
    //     cobro_detalle.tipo_tarjeta_id = tr.tipo_id;
    //     cobro_detalle.valor = tr.valor;
    //     cobro_detalle.plazo = tr.plazo;
    //     cobro_detalle.tiempo = tr.tiempo;
    //     cobro_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
    //     cobro_detalle.empresa_id = this.ss.getData("empresa_id");
    //     cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
    //     cobro_detalle.usuario_id = this.ss.getData("usuario_id");
    //     this.cobro.detalle.push(cobro_detalle);
    // });

    this.ventas.forEach((venta: any, index: number) => {
        if( venta.selected ){

            
            venta.usuario_id = this.ss.getData("usuario_id");
            venta.empresa_id = this.ss.getData("empresa_id");

            this.cobro.grupo.push(venta);
        }

        /*if( this.compra_selected == false){
            this.pago.grupo.splice(index, 1);
        }*/
    });
}
    
  isFormValid(){
    if( this.fecha_cruce.toString().trim().length  === 0 ){
      return false;
    }
    if( this.total_a_cruzar <= 0 ){
      return false;
    }
    if( this.total_facturas == 0 ){
      return false;
    }
    if( this.total_a_cruzar != this.total_facturas ){
      return false;
    }
    return true;
  }
}    


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/cobros/cruce-nota-credito/cruce-nota-credito.component.ts